export const articlesPsychology = [
  {
    id: "psychology-1",
    title: "自慰与情绪：压力释放还是情绪回避",
    summary:
      "很多人发现在压力大时会更想这么做。它到底是有效的情绪调节，还是在回避某些感受？关键在于你如何使用它。",
    cover:
      "https://readdy.ai/api/search-image?query=serene%20abstract%20illustration%20of%20soft%20overlapping%20teal%20and%20peach%20shapes%2C%20calm%20mindfulness%20wellness%20editorial%20style&width=800&height=600&seq=psych-01&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-27",
    readCount: 7210,
    tags: ["情绪", "压力"],
    sections: [
      {
        heading: "它确实能带来放松",
        paragraphs: [
          "身体在过程中释放的化学物质能暂时缓解紧张，这是一种真实的生理反应。",
          "把它当作众多放松方式之一，是完全可以的。",
        ],
      },
      {
        heading: "区分“调节”与“回避”",
        paragraphs: [
          "当它帮助你放松后能继续面对生活，这是一种健康的调节；当你反复用它来逃避压力、悲伤或孤独，它可能变成一种回避。",
          "留意自己使用它的时机与心情，是很好的自我觉察练习。",
        ],
      },
      {
        heading: "多准备几种情绪出口",
        paragraphs: [
          "散步、和朋友聊天、写日记、深呼吸，都可以成为压力到来时的选择。选择越多，你就越自由。",
        ],
      },
    ],
  },
  {
    id: "psychology-2",
    title: "如何与羞耻感和解：性健康的心理基础",
    summary:
      "羞耻感常常比行为本身更让人痛苦。本文想和你聊聊，这种感受从何而来，以及如何温柔地放下它。",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20abstract%20illustration%20of%20a%20soft%20teal%20light%20breaking%20through%20calm%20mist%2C%20minimal%20healing%20wellness%20editorial%20style&width=800&height=600&seq=psych-02&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-24",
    readCount: 5980,
    tags: ["羞耻感", "自我接纳"],
    sections: [
      {
        heading: "羞耻感从哪里来",
        paragraphs: [
          "它大多来自成长环境中的评价、文化禁忌或缺乏正确信息，而不是你本身做错了什么。",
          "理解来源，能帮你把“别人的看法”和“真实的自己”分开。",
        ],
      },
      {
        heading: "和解不是一蹴而就",
        paragraphs: [
          "改变多年形成的感受需要时间，对自己温柔一点，允许自己慢慢来。",
          "用事实替代想象，用理解替代指责，是很有帮助的方向。",
        ],
      },
      {
        heading: "如果你想找人说说话",
        paragraphs: [
          "和信任的朋友倾诉，或寻求心理咨询，都是对自己负责的表现。",
        ],
      },
    ],
  },
  {
    id: "psychology-3",
    title: "自慰后的内疚感从哪里来",
    summary:
      "明明是一件自然的事，却在结束后感到空虚或自责。这种落差很常见，我们来拆解它背后的心理机制。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20abstract%20illustration%20of%20contrasting%20calm%20teal%20and%20warm%20peach%20gradients%2C%20minimal%20psychological%20wellness%20editorial%20style&width=800&height=600&seq=psych-03&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-21",
    readCount: 6340,
    tags: ["内疚", "情绪"],
    sections: [
      {
        heading: "生理与观念之间的落差",
        paragraphs: [
          "身体在事后会进入平静甚至低落的状态，这本是正常的生理过程。",
          "如果这时恰好有“这不应该”的念头出现，就容易被放大成内疚。",
        ],
      },
      {
        heading: "念头不等于事实",
        paragraphs: [
          "试着把“我感到内疚”和“我做错了”区分开，它们并不是一回事。",
          "看见念头的来去，是很有力量的练习。",
        ],
      },
      {
        heading: "用理解替代自责",
        paragraphs: [
          "当你能平静地描述自己的感受，而不是评判它，内疚感往往会慢慢减轻。",
        ],
      },
    ],
  },
  {
    id: "psychology-4",
    title: "焦虑与性冲动：理解身心连接",
    summary:
      "焦虑和身体冲动之间常常相互影响。了解这种联系，有助于你在情绪起伏时更理解自己。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20illustration%20of%20intertwined%20soft%20teal%20and%20sage%20ribbons%20on%20cream%20background%2C%20calm%20wellness%20editorial%20style&width=800&height=600&seq=psych-04&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-18",
    readCount: 4120,
    tags: ["焦虑", "身心"],
    sections: [
      {
        heading: "身体和情绪是连在一起的",
        paragraphs: [
          "紧张、孤独或疲惫都可能让身体更容易产生冲动，这是身心连接的一种表现。",
          "理解这种联系，能减少对自己的困惑。",
        ],
      },
      {
        heading: "先照顾情绪，再回应身体",
        paragraphs: [
          "深呼吸、站起来走动、喝杯水，给情绪一点缓冲，往往能让选择更从容。",
        ],
      },
    ],
  },
  {
    id: "psychology-5",
    title: "建立健康的性观念：从自我接纳开始",
    summary:
      "健康的性观念不是放纵，也不是压抑，而是建立在了解、尊重和接纳之上的从容态度。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20illustration%20of%20a%20growing%20teal%20leaf%20with%20soft%20orange%20sun%2C%20wellness%20editorial%20style&width=800&height=600&seq=psych-05&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-15",
    readCount: 3890,
    tags: ["观念", "接纳"],
    sections: [
      {
        heading: "从了解开始",
        paragraphs: [
          "很多不安都来自信息不足。获取科学的知识，是建立健康观念的第一步。",
        ],
      },
      {
        heading: "尊重自己的节奏",
        paragraphs: [
          "每个人的需求与边界都不同，没有统一的标准答案。尊重自己的感受，也尊重他人的选择。",
        ],
      },
      {
        heading: "把身体当作朋友",
        paragraphs: [
          "用好奇与关照的态度对待身体，而不是评判与对抗，你会更自在。",
        ],
      },
    ],
  },
  {
    id: "psychology-6",
    title: "自慰与睡眠：放松身心的科学机制",
    summary:
      "不少人发现事后更容易入睡。这背后有生理与心理的双重原因，本文带你了解其中的机制。",
    cover:
      "https://readdy.ai/api/search-image?query=peaceful%20abstract%20night%20illustration%20with%20deep%20teal%20and%20warm%20amber%20accents%2C%20calm%20sleep%20wellness%20editorial%20style&width=800&height=600&seq=psych-06&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-12",
    readCount: 4760,
    tags: ["睡眠", "放松"],
    sections: [
      {
        heading: "身体为什么放松",
        paragraphs: [
          "过程中与之后的激素变化会让肌肉放松、焦虑感下降，从而更容易入睡。",
        ],
      },
      {
        heading: "它只是众多助眠方式之一",
        paragraphs: [
          "规律作息、减少屏幕时间、睡前放松练习同样重要。把它当作工具箱里的一件工具即可。",
        ],
      },
    ],
  },
  {
    id: "psychology-7",
    title: "当自慰成为逃避：识别情绪依赖的信号",
    summary:
      "偶尔用它缓解情绪很正常。但如果它成了面对一切情绪的“快捷键”，可能就值得多留意一下。",
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20minimal%20illustration%20of%20a%20sheltering%20teal%20curve%20over%20soft%20peach%20background%2C%20quiet%20wellness%20editorial%20style&width=800&height=600&seq=psych-07&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-09",
    readCount: 3510,
    tags: ["依赖", "觉察"],
    sections: [
      {
        heading: "几个可以自查的信号",
        paragraphs: [
          "是否一到情绪低落就立刻需要它？是否因此回避了其他重要的事？是否越来越难获得满足？",
          "这些信号不是用来指责自己，而是帮助你更了解自己。",
        ],
      },
      {
        heading: "给情绪留出空间",
        paragraphs: [
          "练习先感受情绪、命名情绪，再决定如何回应，能让行为更有选择。",
        ],
      },
    ],
  },
  {
    id: "psychology-8",
    title: "正念与身体觉察练习",
    summary:
      "正念帮助你与身体建立更友善的连接。这里有几个简单、随时可做的练习，适合日常坚持。",
    cover:
      "https://readdy.ai/api/search-image?query=zen%20minimal%20abstract%20illustration%20of%20concentric%20soft%20teal%20circles%20with%20warm%20sand%20tones%2C%20mindfulness%20wellness%20editorial%20style&width=800&height=600&seq=psych-08&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-06",
    readCount: 5230,
    tags: ["正念", "练习"],
    sections: [
      {
        heading: "什么是身体觉察",
        paragraphs: [
          "它指的是把注意力温和地放回身体感受上，不加评判，只是观察。",
          "这能帮助你更早地察觉压力与情绪，而不是被它们推着走。",
        ],
      },
      {
        heading: "一个三分钟练习",
        paragraphs: [
          "闭上眼，慢慢呼吸，从头顶到脚趾依次感受身体。走神了就温柔地把注意力带回来。",
        ],
      },
    ],
  },
  {
    id: "psychology-9",
    title: "伴侣关系中的沟通与理解",
    summary:
      "在亲密关系中，如何谈论身体、需求与边界？坦诚而不评判的沟通，是关系健康的重要基础。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20illustration%20of%20two%20interlocking%20soft%20teal%20and%20peach%20shapes%2C%20harmony%20wellness%20editorial%20style&width=800&height=600&seq=psych-09&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-09-03",
    readCount: 5600,
    tags: ["关系", "沟通"],
    sections: [
      {
        heading: "为什么难以开口",
        paragraphs: [
          "关于身体与需求的话题常让人紧张，担心被误解或被拒绝。",
          "但交流不畅往往是误解的源头，而不是关系的问题本身。",
        ],
      },
      {
        heading: "从“我”开始表达",
        paragraphs: [
          "用“我感到……”“我希望……”的句式，比指责更容易被听见。",
          "倾听对方同样重要，理解彼此节奏比达成一致更优先。",
        ],
      },
    ],
  },
  {
    id: "psychology-10",
    title: "青少年到成年：性心理的正常发展",
    summary:
      "从青春期到成年，性心理会经历一系列变化。了解这些阶段，有助于家长与年轻人减少困惑与焦虑。",
    cover:
      "https://readdy.ai/api/search-image?query=hopeful%20minimal%20abstract%20illustration%20of%20a%20rising%20teal%20path%20with%20soft%20warm%20light%2C%20development%20wellness%20editorial%20style&width=800&height=600&seq=psych-10&orientation=landscape",
    categoryId: "psychology",
    author: "编辑部",
    date: "2026-08-31",
    readCount: 2980,
    tags: ["成长", "发展"],
    sections: [
      {
        heading: "变化是成长的一部分",
        paragraphs: [
          "青春期身体与心理都会发生变化，好奇与冲动是这一阶段常见的体验。",
          "获得科学的信息与支持，能让这段时期更顺利。",
        ],
      },
      {
        heading: "沟通比回避更有帮助",
        paragraphs: [
          "家长与教育者以开放、平和的态度谈论这些话题，能帮助年轻人建立健康的观念。",
        ],
      },
    ],
  },
];